export const Interior = {
  pdf: {
    text: 'See the printable reference tool.',
    link: 'https://file.kbb.com/kbb/images/ico/conditionRedesign/interior/20180719ConditionTool.pdf',
  },
  title: 'Examples of Wear or Damage',
  exclude: ['Cargo Bed'],
  content: [
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/interior/stains.png',
      title: 'Stains',
      text: 'Marks caused by spilled liquids or other substances. If the stain is not removable, it is considered severe.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/interior/rips-or-tears.png',
      title: 'Rips or Tears',
      text: 'Damage caused by excess wear or accidental tears from sharp items. Must be less than 3 inches.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/interior/burns.png',
      title: 'Burn',
      text: 'A hole often caused by smoking. A burn smaller than a pen tip is minor and repairable. More than one burn is considered severe damage.',
    },
    {
      src: 'https://file.kbb.com/kbb/images/ico//conditionRedesign/interior/worn-upholstery.png',
      title: 'Signs of Wear',
      text: 'Visible wear and tear, which may include: thinning of seat upholstery, fraying of the carpet, cracks in the dashboard, or obvious wear of the headliner.',
    },
    {
      title: 'Broken Seat Frame',
      text: 'Severe damage caused by accidents or excess wear.',
    },
    {
      title: 'Severe Signs of Damage',
      text: 'Damage caused by stains, rips or tears, and burns. In many cases, the part needs to be replaced.',
    },
    // {
    //   title: 'Airbags Deployed or Missing',
    //   text: 'Airbags that weren’t replaced after an accident or are missing.',
    // },
  ],
}
